/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServiceConfigurationSearchRequestModel } from '../../models/service-configuration-search-request-model';
import { ServiceConfigurationSearchResultModel } from '../../models/service-configuration-search-result-model';

export interface ServiceConfigurationSearchPost$Params {
      body?: ServiceConfigurationSearchRequestModel
}

export function serviceConfigurationSearchPost(http: HttpClient, rootUrl: string, params?: ServiceConfigurationSearchPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<ServiceConfigurationSearchResultModel>>> {
  const rb = new RequestBuilder(rootUrl, serviceConfigurationSearchPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<ServiceConfigurationSearchResultModel>>;
    })
  );
}

serviceConfigurationSearchPost.PATH = '/ServiceConfiguration/Search';
